<div #contentDiv class="max-w-lg mx-auto flex-col pt-20 text-theme-text">
  <div class="flex-1 bg-theme-surface rounded-t-3xl min-h-[calc(100vh-5rem)]">
    <div class="flex flex-row pt-6 px-4 pb-4 items-center">
      <div class="mr-3">
        <app-circle-button [icon]="'fa-chevron-left'" size="12" type="solid" fontSize="xl" (onClick)="back()"></app-circle-button>
      </div>
      <div class="ml-2 text-theme-text text-3xl break-words w-[calc(100%-3rem)]">{{getString("Presentkort")}}</div>
    </div>

    <div class="w-full" *ngIf="reciverLayout && giftcard">
      <div *ngIf="isLoading" class="w-64 h-64 border-4 border-theme-primary rounded-2xl gap-6 flex flex-col items-center mx-auto mt-16 mb-16">
        <i class="fas fa-gift text-4xl text-theme-primary mt-12"></i>
        <div class="font-bold text-theme-primary">Presenkort hämtas...</div>
        <app-loading-spinner size="lg"></app-loading-spinner>
      </div>
      <div *ngIf="imageUrl" class="mt-4 text-theme-text2">
        <img
          [src]="imageUrl"
          alt="Gift Card"
          [class.hidden]="isLoading"
          (load)="onImageLoaded()"
          (error)="onImageError()"
        >

        <div *ngIf="!isLoading" class="mx-8 font-bold my-6">Grattis till ditt presentkort! Presentkortet kan användas vid ditt nästa besök hos oss.</div>
        <div *ngIf="!isLoading" class="mx-8 font-bold my-6">Presentkortet är en värdehandling - förvara det säkert och dela inte med obehöriga.</div>
      </div>

      <div class="flex justify-center gap-4 pt-4">
        <app-light-icon-button leftIcon="fa-paper-plane" [text]="getString('Skicka')" (onClick)="send()"></app-light-icon-button>
        <app-light-icon-button leftIcon="fa-download" [text]="getString('Ladda ner')" (onClick)="download()"></app-light-icon-button>
      </div>

      <div class="h-16">

      </div>
    </div>


    <div class="mt-8 mx-8 px-4 pt-4 pb-2 border-2 border-theme-text-50 rounded-2xl shadow-xl text-theme-text" *ngIf="!reciverLayout && giftcard">
      <div class="flex items-center text-3xl gap-2">
        <i class="fas fa-gift"></i>
        <div class="font-bold">{{getString("Presentkort")}}</div>
      </div>
      <div class="mt-6 font-bold">{{getString("Till")}} {{receiverName}}</div>
      <div class="mt-1 font-bold text-3xl tabular-nums">{{amount}}</div>
      <div class="my-4">
        <app-separator color="border-theme-text"></app-separator>
      </div>
      <div class="flex justify-between">
        <app-light-icon-button leftIcon="fa-paper-plane" [text]="getString('Skicka')" (onClick)="send()"></app-light-icon-button>
        <app-light-icon-button leftIcon="fa-download" [text]="getString('Ladda ner')" (onClick)="download()"></app-light-icon-button>
      </div>
      <div class="my-4">
        <app-separator color="border-theme-text"></app-separator>
      </div>
      <div class="text-theme-text3 font-bold">{{getString("Tack så mycket för köpet av presentkort. Vi hoppas det kommer väl till användning!")}}</div>
      <div class="text-theme-text3 mt-2 font-bold">{{getString("Tänk på att presentkortet är en värdehandling. Ge ingen obehörig tillgång till kortet.")}}</div>
      <div class="text-end text-theme-text3 mt-2 font-bold">{{lastFour}}</div>
    </div>

  </div>
</div>

